import React, { useCallback, useRef } from 'react'

import { SwiperPaymentModal } from '../../../payments/swiper-payment-modal/react/SwiperPaymentModal'
import { Transaction } from '../../../payments/swiper-payment-modal/react/queries/Transaction'
import { convertTransactionToApiTransaction } from '../../../../functions/payments'

import { useWebRegisterStatusManager } from '../../../../ng-compat/hooks'
import { useHandleSwiperPaymentSuccess } from '../hooks/useHandleSwiperPaymentSuccess'
import { SalePayment, SwiperPaymentOption } from './types'
import { SwiperOfflineModal } from './SwiperOfflineModal'

type Props = {
  paymentOptions: SwiperPaymentOption
  onSuccess: (result: SalePayment) => void
  onClose: () => void
}

export const SwiperPayment = ({
  paymentOptions,
  onSuccess,
  onClose,
}: Props) => {
  const webRegisterStatusManager = useWebRegisterStatusManager()
  const handleSwiperPaymentSuccess = useHandleSwiperPaymentSuccess()
  const handleClosed = useRef(false) // FIXME: useRef works but ideally we should fix the issue with the component re-rendering. Need to roll out payment panel to react before fixing this at children level

  const closeModal = useCallback(
    (transaction?: Transaction) => {
      if (!transaction) {
        onClose()
        return
      }
      if (handleClosed.current) {
        return
      }
      handleClosed.current = true
      const { registerId, paymentType, currency, amount } = paymentOptions

      const apiTransaction = convertTransactionToApiTransaction(transaction, {
        registerId,
        retailerPaymentType: paymentType,
        currency,
      })
      const salePayment = handleSwiperPaymentSuccess({
        transaction: apiTransaction,
        paymentType,
        amountTendered: amount,
      })
      if (!salePayment) {
        onClose()
        return
      }
      onClose()
      onSuccess(salePayment)
      return
    },
    [onClose, onSuccess, paymentOptions, handleSwiperPaymentSuccess]
  )

  const isOffline = !webRegisterStatusManager.isOnline() || !navigator.onLine
  const { registerId, paymentType, amount, currency } = paymentOptions
  if (isOffline) {
    return (
      <SwiperOfflineModal onClose={onClose} paymentName={paymentType.name} />
    )
  }

  return (
    <SwiperPaymentModal
      registerId={registerId}
      retailerPaymentType={paymentType}
      amount={amount}
      currency={currency}
      closeModal={closeModal}
    />
  )
}
